import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const ProductBalance: React.FC<Props> = ({
  accessibilityLabel,
  className,
}) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      {...iconAccessibility(accessibilityLabel)}
    >
      <g
        fill='none'
        stroke='currentColor'
        strokeLinejoin='round'
        strokeWidth='1.5'
      >
        <circle cx={12} cy={12} r={8} />
        <path d='M7.3 9.08h4M7.3 12.08h4M7.3 15.08h4M12.8 12.08h4M12.8 15.08h4' />
      </g>
    </svg>
  </i>
);

ProductBalance.displayName = 'ProductBalance';
export default ProductBalance;
